import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

const SearchDateFilter = ({
	searchValue,
	setSearchValue,
	startDate,
	setStartDate,
	endDate,
	setEndDate,
}) => {
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: { md: "row", xs: "column" },
				mb: "1rem",
			}}
		>
			<Box
				sx={{
					width: {
						md: "50%",
						xs: "100%",
					},
					mb: {
						md: 0,
						xs: "1rem",
					},
				}}
			>
				<TextField
					id="search"
					label="Search Customer"
					sx={{ width: { md: "70%", xs: "100%" } }}
					value={searchValue}
					onChange={(e) => setSearchValue(e.target.value)}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<SearchIcon />
							</InputAdornment>
						),
					}}
					variant="outlined"
				/>
			</Box>
			<Box
				sx={{
					ml: { md: "auto", xs: 0 },
					display: "flex",
					flexDirection: { md: "row", xs: "column" },
				}}
			>
				<Box sx={{ mr: { md: "1rem", xs: 0 }, mb: { xs: "1rem", md: 0 } }}>
					<LocalizationProvider dateAdapter={AdapterDateFns}>
						<DatePicker
							label="Start Date"
							value={startDate}
							onChange={(newValue) => {
								setStartDate(newValue);
							}}
							renderInput={(params) => <TextField {...params} />}
						/>
					</LocalizationProvider>
				</Box>
				<Box>
					<LocalizationProvider dateAdapter={AdapterDateFns}>
						<DatePicker
							label="End Date"
							value={endDate}
							onChange={(newValue) => {
								setEndDate(newValue);
							}}
							renderInput={(params) => <TextField {...params} />}
						/>
					</LocalizationProvider>
				</Box>
			</Box>
		</Box>
	);
};

export default SearchDateFilter;
